export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION;
export const BUILT_AT: string = import.meta.env.VITE_BUILT_AT;
